<lib-ph-bhp-startpuzzle [sopId]="this.sopId" [userData]="appConfig.userData" (childData)="childData($event)"></lib-ph-bhp-startpuzzle>
 
